import { AuditableResponse } from "../common/AuditableResponse"
import { ServiceField } from "./ServiceField"

export class ServiceDetails extends AuditableResponse {
  id: number
  allowDiscounts: boolean
  description: string
  name: string
  price: number
  sku: string
  buildStepId?: number
  serviceFields: ServiceField[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, allowDiscounts?: boolean, description?: string, name?: string, price?: number, sku?: string, buildStepId?: number, serviceFieldsJson?: any, createdByUserJson?: any, createdDate?: string, lastModifiedByUserJson?: any, lastModifiedDate?: string) {
    super(createdByUserJson, createdDate, lastModifiedByUserJson, lastModifiedDate)
    this.id = id
    this.allowDiscounts = allowDiscounts ?? true
    this.buildStepId = buildStepId
    this.description = description ?? ''
    this.name = name ?? ''
    this.price = price ?? 0
    this.sku = sku ?? ''
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.serviceFields = serviceFieldsJson ? serviceFieldsJson.map((s: any) => new ServiceField(s.id, s.name, s.type, s.serviceFieldOptions)) : []
  }
}
